import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")

  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([{'_tc--error': $options.isMarked}])
  }, [
    ($props.isIconVisible)
      ? (_openBlock(), _createBlock(_component_base_icon, {
          key: 0,
          name: $options.iconName,
          class: "_mr-1"
        }, null, 8 /* PROPS */, ["name"]))
      : _createCommentVNode("v-if", true),
    _createTextVNode(" " + _toDisplayString($options.label), 1 /* TEXT */)
  ], 2 /* CLASS */))
}